<template>
<div class="content">

    <!-- <div class="nav">
        <div class="logo">
            <span class="iconfont lh-icon-logo"></span>
        </div>
        <lh-nav-menu>
            <lh-menu-group>
                <div slot="groupName">书签导航</div>
                <lh-menu-item to="/">主页</lh-menu-item>
                <lh-menu-item to="/bookmarks">我的书签</lh-menu-item>
            </lh-menu-group>
            <lh-menu-group>
                <div slot="groupName">我的工具</div>
                <lh-menu-item to="/coding">coding</lh-menu-item>
                <lh-menu-item to="/test">测试实验</lh-menu-item>
            </lh-menu-group>
            <lh-menu-group>
                <div slot="groupName">后台管理</div>
                <lh-menu-item to="/favorites">收藏夹</lh-menu-item>
            </lh-menu-group>
        </lh-nav-menu>
    </div> -->

    <!-- <div class="view">
        <router-view/>
    </div> -->

    <lh-size-layout>
        <div slot="left">
            <div class="nav">
                <div>
                    <div class="logo">
                        <span class="iconfont lh-icon-logo"></span>
                    </div>
                    <lh-nav-menu>
                        <lh-menu-group>
                            <div slot="groupName">书签导航</div>
                            <lh-menu-item to="/">主页</lh-menu-item>
                            <lh-menu-item to="/bookmarks">我的书签</lh-menu-item>
                        </lh-menu-group>
                        <lh-menu-group>
                            <div slot="groupName">我的工具</div>
                            <lh-menu-item to="/coding">coding</lh-menu-item>
                            <lh-menu-item to="/test">测试实验</lh-menu-item>
                        </lh-menu-group>
                        <lh-menu-group>
                            <div slot="groupName">后台管理</div>
                            <lh-menu-item to="/dataBase">数据库管理</lh-menu-item>
                            <lh-menu-item to="/favorites">收藏夹</lh-menu-item>
                            <lh-menu-item to="/mpim">摩斯输入法</lh-menu-item>
                        </lh-menu-group>
                    </lh-nav-menu>
                </div>
                <div style="font-size: 13px;color: gainsboro;">粤ICP备2024233111号-4</div>
            </div>
        </div>

        <div class="view">
            <div class="head" v-if="user">
                <div>{{ user.account }}</div>
                <lh-button @click="loginOut">退出登录</lh-button>
            </div>
            <router-view/>
        </div>
    </lh-size-layout>
    
</div>
</template>

<script>
export default {
  name:"Index",
  data(){
    return {
        user:null
    }
  },
  mounted(){
    this.user=JSON.parse(localStorage.getItem("user"));
    // console.log("user",this.user);
  },
  methods:{
    loginOut:function(){
        localStorage.setItem("user",null);
        this.$router.push({path:"/login"});
    }
  }
}
</script>

<style lang="less" scoped>
.content{
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    .nav{
        height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        padding:5px;
        // border: solid;
        .logo{
            padding: 10px;
            .lh-icon-logo{
                font-size: 100px;
            }
        }
        // width: 15%;
        //border: solid;
        box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
    }
    .view{
        // width:85%;
        display: flex;
        flex-direction: column;
        height: 100%;
        .head{
            width:100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }
        // overflow: auto;
        //border: solid;
    }
}
</style>